export default "__VITE_ASSET__CMk$YIfR__"